var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 156,
    viewBox: "0 0 229 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ornament"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    y: 105.914,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    y: 52.9911,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21",
    y: 0.0687256,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 52.9225,
    y: 105.914,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FCD87D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 52.9225,
    y: 52.9911,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    x: 52.9225,
    y: 0.0687256,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 105.845,
    y: 105.914,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 105.845,
    y: 52.9911,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 105.845,
    y: 0.0687256,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 158.767,
    y: 105.914,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19",
    x: 158.767,
    y: 52.9911,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FCD87D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    x: 158.767,
    y: 0.0687256,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 211.69,
    y: 105.914,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 20",
    x: 211.69,
    y: 52.9911,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 211.69,
    y: 0.0687256,
    width: 17.164,
    height: 17.164,
    rx: 8.58201,
    fill: "#FFE8C4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubImg);
export default __webpack_public_path__ + "static/media/sub-img.69454d4f814864973144fb065a34f777.svg";
export { ForwardRef as ReactComponent };